import React from "react";
import { makeStyles, TextField, Theme } from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";

const filterOptions = createFilterOptions({
  matchFrom: "start",
});
const useStyles = makeStyles((theme: Theme) => ({
  autocomplete: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.60)",
    },
  },
  label: {
    backgroundColor: "white",
    paddingRight: "5px",
  },
  inputRoot: {
    "&$disabled": {
      color: "rgba(0, 0, 0, 0.70)",
    },
  },
  disabled: {},
}));

type opt = {
  value: string;
  label: string;
};
interface Props {
  label?: string;
  optionsType?: opt[];
  error?: boolean;
  helperText?: any;
  selectedOption?: string;
  handleChange?: (v: string) => void;
  getOptionLabel: (option: any) => any;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  value?: any;
  loading?: boolean;
  disableClearable?: any;
  onChange?: (v: any) => void;
  onBlur?: (e: any) => void;
  placeholder?: string;
  returnValue?: string;
  compaireValue?: string;
  notToLowerCase?: boolean;
  makeCustomType?: boolean;
}

export default function CommonAutoCompleteField({
  label = "Add Label",
  optionsType,
  error,
  handleChange,
  getOptionLabel,
  required = false,
  name = "",
  value = null,
  loading = false,
  disableClearable = false,
  helperText,
  placeholder,
  onChange,
  onBlur,
  disabled,
  returnValue = "value",
  compaireValue = "label",
  notToLowerCase = false,
  makeCustomType = false,
}: Props) {
  const classes = useStyles();
  const [defOpt, setDefOpt] = React.useState<any>();
  return (
    <Autocomplete
      id={name}
      size="small"
      fullWidth
      disabled={disabled}
      loading={loading}
      options={optionsType || []}
      disableClearable={disableClearable}
      value={value}
      onInputChange={(_e, v) => {
        if ((v === "" || v.length === 1) && _e && _e?.type === "change") {
          setDefOpt({});
        }
        handleChange && handleChange(v);
      }}
      filterOptions={filterOptions}
      autoComplete
      openOnFocus
      className={classes.autocomplete}
      onChange={(e, v) => {
        onChange && onChange(v);
        if (e && e.type === "click") {
          setDefOpt(v);
          //onChange && onChange(o);
        }
      }}
      getOptionLabel={(option) => getOptionLabel(option)}
      includeInputInList
      //blurOnSelect={true}
      onHighlightChange={(e: any, o: any, r: any) => {
        if (e && o && r && e.type != "mouseover") {
          setDefOpt(o);
          //onChange && onChange(o);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          key={`${label}ConfirmationCode`}
          required={required}
          error={error}
          helperText={helperText}
          id="outlined-basic"
          label={label}
          name={name}
          placeholder={placeholder || ""}
          variant="outlined"
          size="small"
          onBlur={(e) => {
            if (compaireValue && optionsType?.length && !makeCustomType) {
              if (defOpt && Object.keys(defOpt).length) {
                onChange && onChange(defOpt);
                onBlur && returnValue && returnValue !== "none" && onBlur(defOpt[returnValue]);
              } else if (e && e.target.value) {
                const filterSet: any = optionsType.find((item: any) =>
                  compaireValue !== "none"
                    ? notToLowerCase
                      ? item[compaireValue]?.startsWith(e.target.value)
                      : item[compaireValue]?.toLowerCase().startsWith(e.target.value?.toLowerCase())
                    : item?.toLowerCase().startsWith(e.target.value?.toLowerCase())
                );
                if (filterSet) {
                  onChange && onChange(filterSet);
                  onBlur && returnValue && returnValue !== "none" && onBlur(filterSet[returnValue]);
                }
              }
            } else if (makeCustomType && e && e.target.value) {
              onBlur && returnValue && returnValue !== "none" && onBlur(e.target.value);
            }
          }}
          InputLabelProps={{
            shrink: true,
            classes: {
              root: classes.label,
            },
          }}
          fullWidth
        />
      )}
    />
  );
}
